import { useState } from "react";
import { useSeo } from "@/lib/seo";
import { IMAGES, PARTNER_CATEGORIES } from "@/data/site";
import PageHero from "@/components/PageHero";
import { Reveal, Overline } from "@/components/Reveal";
import LeadForm from "@/components/LeadForm";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Server, Building2, TrendingUp, Zap, Hammer, MapPin, Handshake, Landmark, HardHat, Network } from "lucide-react";

const ICONS = [Server, Building2, TrendingUp, Zap, Hammer, MapPin, Handshake, Landmark, HardHat, Network];

export default function Partners() {
  useSeo("Partner With 12 Stone Development Group",
    "Inquiry pathways for data center operators, developers, investors, utilities, builders, landowners, brokers, economic development authorities, general contractors and infrastructure providers.");
  const [active, setActive] = useState(null);
  return (
    <div>
      <PageHero overline="Partnerships" title="Partner With 12 Stone"
        subtitle="Development happens through relationships. Choose your pathway and start a conversation with our team."
        image={IMAGES.substation} />

      <section className="max-w-7xl mx-auto px-4 sm:px-6 py-20">
        <Reveal><Overline>Select Your Pathway</Overline></Reveal>
        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {PARTNER_CATEGORIES.map((c, i) => {
            const Icon = ICONS[i % ICONS.length];
            return (
              <Reveal key={c} delay={(i % 3) * 0.05}>
                <button onClick={() => setActive(c)} data-testid={`partner-card-${i}`}
                  className="group w-full text-left rounded-xl border border-border bg-card p-7 hover:border-primary/40 hover:bg-muted transition-all h-full">
                  <div className="h-11 w-11 rounded-lg bg-primary/10 border border-primary/20 flex items-center justify-center text-primary mb-4 group-hover:scale-110 transition-transform"><Icon className="h-5 w-5" /></div>
                  <h3 className="font-display text-lg font-semibold text-foreground">{c}</h3>
                  <p className="mt-3 text-sm text-primary opacity-0 group-hover:opacity-100 transition-opacity">Start inquiry →</p>
                </button>
              </Reveal>
            );
          })}
        </div>
      </section>

      <Dialog open={!!active} onOpenChange={(o) => !o && setActive(null)}>
        <DialogContent className="bg-card border-border max-w-lg">
          <DialogHeader><DialogTitle className="font-display text-foreground">{active} Inquiry</DialogTitle></DialogHeader>
          {active && <LeadForm leadType="partner" defaultCategory={active} submitLabel="SUBMIT INQUIRY" testId="partner-inquiry" />}
        </DialogContent>
      </Dialog>
    </div>
  );
}
